import { IExactScoreBets } from '@features/super-exact-score/api/superExactScore.type';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { FC, useEffect } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

interface ISuperExactScoreEventProps {
  bet?: IExactScoreBets,
  host:string,
  guest:string,
  champ:string,
  date: any,
  onClick: any,
  id: number,
  selected: any
  onlineTime: any,
  eventResult: string
}
const SuperExactScoreEvent:FC<ISuperExactScoreEventProps> = ({
  bet,
  host,
  guest,
  champ,
  date,
  onlineTime,
  eventResult,
  id,
  onClick,
  selected,
}) => {

  const unixDate= new Date(date * 1000);
  const now = Date.now();
  let betStatus = null;
  const isFinished = !(bet && bet[id]) && (!!eventResult || date * 1000 < Date.now())

  if (bet) {
    betStatus = bet[id] ? bet[id]?.status : '';
  }

  useEffect(() => {
    if (unixDate.getTime() < now) {
      console.log('Время прошло');
      // …сюда логика для уже прошедших дат
    } else {
      console.log('Время ещё не наступило');
      // …сюда логика для будущих дат
    }
  }, [ onlineTime]);

  return (
    <Box
      onClick={!isFinished ? onClick : undefined}
      className="super-exact-score-events-item"
      data-status={isFinished ? '6' : betStatus}
      data-selected={selected}
    >
      <Box className="super-exact-score-event-champ">
        <Typography fontSize="1.4em" textTransform="uppercase">
          {champ}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between">
        <Box className="super-exact-score-event-opponent">
          <Typography fontSize="1.2em" textTransform="uppercase">
            {host}
          </Typography>
        </Box>
        <Box
          className="super-exact-score-event-date">
          <Typography fontSize="1.2em" marginTop={0.5}>
            <FormattedDate day="2-digit" month="short" value={unixDate}/>
            <br/>
            <FormattedTime value={unixDate}/>
          </Typography>
        </Box>
        <Box className="super-exact-score-event-opponent">
          <Typography fontSize="1.2em" textTransform="uppercase">
            {guest}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
export default SuperExactScoreEvent;